/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteActivityLog
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete activity log
 *
 */
interface IProps {
	entityType: ClaimWorkLists.IWorkListEntityType;
	entityId: string;
	activityLogId: string;
}
const useDeleteActivityLog = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ entityType, entityId, activityLogId }) => {
			await api.ActivityLogApi.deleteActivityLog({ entityType, entityId, activityLogId });
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimActivityLogs] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteActivityLog;
